import { Icon } from "@iconify/react";
import { Button, Drawer, Modal, Spin, Tooltip, Typography } from "antd";
import { get } from "lodash";
import React, { useState } from "react";
import { RegisterOptions } from "react-hook-form";
import { useNotification } from "~/Hooks/useNotification";
import { getDateFormat, getFormattedDate, getStartDate } from "~/Utils/CommonUtils";
import { getCurrentModule } from "~/Utils/StringConstants";
import { passengerAirportColumn, renderImageColumn } from "~/Utils/TableRenderFunction";
import { DynamicRowConfig, OptionType } from "../DynamicForm/DynamicForm";
import ConfirmationModal from "../Modal/confirmation-modal";
import AsyncDataDisplay from "./AsyncDataDisplay";

interface Field {
  fieldName: string;
  fieldValue: string | string[];
  className?: string;
  parseField?: string;
  type:
    | "number"
    | "mobile"
    | "text"
    | "textarea"
    | "image"
    | "date"
    | "checkbox"
    | "content"
    | "video"
    | "dateTime"
    | "dateFormat"
    | "pdf"
    | "select"
    | "dynamicRow"
    | (
        | "number"
        | "text"
        | "textarea"
        | "image"
        | "checkbox"
        | "content"
        | "video"
        | "date"
        | "dateTime"
        | "dateFormat"
        | "pdf"
        | "select"
        | "dynamicRow"
        | "mobile"
      )[];
  formType?: string;
  label: string;
  placeholder: string;
  validation?: RegisterOptions;
  options?: OptionType[];
  loadOptions?: () => Promise<OptionType[]>;
  editable?: boolean;
  hidden?: boolean;
  usedFileType?: string;
  dynamicFormType?: string;
  rowConfig?: DynamicRowConfig[];
}

export interface Action {
  label: any;
  type?: "primary" | "default" | "dashed" | "link" | "text" | "ghost";
  onClick: (reason?: string) => void;
  disabled?: boolean;
}

interface TableDrawerProps {
  title: React.ReactNode;
  visible: boolean;
  onClose: () => void;
  fields: Field[] | undefined;
  actions?: Action[];
  data?: any;
  isLoading?: boolean;
  reviewNotes?: string;
  copyClipboard?: boolean;
  onReplyClick?: () => void;
  draftCount?: number;
  moduleName?: string;
  airportName?: string;
}

export const TableDrawer: React.FC<TableDrawerProps> = ({
  title,
  visible,
  onClose,
  fields,
  actions,
  data,
  isLoading,
  reviewNotes,
  copyClipboard,
  onReplyClick,
  draftCount,
  moduleName,
  airportName,
}) => {
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [approveModalVisible, setApproveModalVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [onClickFunction, setOnClickFunction] = useState<Function>();
  const [reason, setReason] = useState("");
  const [error, setError] = useState(false);
  const { openToast } = useNotification();
  const currentModule = getCurrentModule();
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState<string>("");

  function decodeHtml(str: string = ""): string {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }
  function cleanAndFixHtml(html: string): string {
    // First, remove any <a href> tags and extract just the URL
    let cleaned = html.replace(/<a\s+href="([^"]+)"[^>]*>([^<]*)<\/a>/gi, "$1");

    // Fix malformed image tags where quotes might be missing or encoded wrong
    cleaned = cleaned.replace(/<img\s+src="([^";\s]+)[^>]*>/gi, '<img src="$1" alt="Image">');

    return cleaned;
  }

  function decodeValue(value: any): React.ReactNode {
    const firstDecode = decodeHtml(value);
    const secondDecode = decodeHtml(firstDecode);
    const cleaned = cleanAndFixHtml(secondDecode);

    console.log("Final HTML:", cleaned);

    return (
      <div
      className="formatted-html-content"
        dangerouslySetInnerHTML={{
          __html: value,
        }}
      />
    );
  }
  console.log(data, "drawer data");
  console.log(fields, "field");
  // function decodeValue(value: any): string {
  //   if (!value) return "";

  //   const parser = new DOMParser();
  //   const doc = parser.parseFromString(value, "text/html");
  //   return doc.body.textContent || "";
  // }

  async function approveRequest() {
    if (onClickFunction) {
      try {
        await onClickFunction();
      } catch (err) {}
    }
  }

  async function rejectRequest(reason: string) {
    if (onClickFunction) {
      try {
        await onClickFunction(reason);
      } catch (err) {}
    }
  }

  // Helper function to render select field values
  // const renderSelectValue = (field: Field, value: string | string[] | undefined) => {
  //   if (!value) return <Typography.Text>N/A</Typography.Text>;

  //   if (field.loadOptions) {
  //     return (
  //       <AsyncDataDisplay
  //         field={field}
  //         value={value}
  //       />
  //     );
  //   }

  //   if (!field.options) return <Typography.Text>{value}</Typography.Text>;

  //   const values = Array.isArray(value) ? value : value.split(",").map((v) => v.trim());

  //   const selectedLabels = values
  //     .map((val) => {
  //       const option = field.options!.find((opt) => opt.value === val);
  //       return option ? option.label : val;
  //     })
  //     .join(", ");

  //   console.log(selectedLabels, value, "selectedLabels");

  //   return <Typography.Text>{selectedLabels || value}</Typography.Text>;
  // };

  // const renderSelectValue = (field: Field, value: any) => {
  //   if (!value) return <Typography.Text>N/A</Typography.Text>;

  //   // If the field loads options asynchronously
  //   if (field.loadOptions) {
  //     return (
  //       <AsyncDataDisplay
  //         field={field}
  //         value={value}
  //       />
  //     );
  //   }

  //   // If the field has predefined options
  //   if (!field.options) return <Typography.Text>{JSON.stringify(value)}</Typography.Text>;

  //   // Normalize value to an array
  //   const valuesArray = Array.isArray(value) ? value : value.split(",").map((v: any) => v.trim());

  //   const selectedLabels = valuesArray
  //     .map((val: any) => {
  //       // If val is an object with a label
  //       if (typeof val === "object" && val.label) return val.label;

  //       // Otherwise, match from options
  //       const option = field.options!.find((opt) => opt.value === val);
  //       return option ? option.label : val;
  //     })
  //     .join(", ");

  //   console.log(selectedLabels, value, "selectedLabels");

  //   return <Typography.Text>{selectedLabels || JSON.stringify(value)}</Typography.Text>;
  // };

  const renderSelectValue = (field: Field, value: any) => {
    if (!value) return <Typography.Text></Typography.Text>;

    // If the field loads options asynchronously
    if (field.loadOptions) {
      return (
        <AsyncDataDisplay
          field={field}
          value={value}
        />
      );
    }

    // Normalize value to an array
    const valuesArray: any[] = Array.isArray(value)
      ? value
      : typeof value === "object"
        ? [value]
        : value
            .toString()
            .split(",")
            .map((v: string) => v.trim())
            .filter(Boolean);

    // Remove duplicates (optional)
    const uniqueValues = Array.from(new Set(valuesArray));

    // Map to option labels if options exist
    const selectedLabels = uniqueValues
      .map((val) => {
        if (!val) return null;

        if (typeof val === "object" && (val as any)?.label) return (val as any).label;

        if (field.options) {
          const option = field.options.find((opt) => opt.value === val);
          return option ? option.label : val;
        }

        return val;
      })
      .filter(Boolean);

    return (
      <Typography.Text>
        {selectedLabels.length > 0
          ? selectedLabels.map((label, index) => <div key={index}>{decodeValue(label)}</div>)
          : ""}
      </Typography.Text>
    );
  };

  const handleImageClick = (src: string) => {
    setModalImageSrc(src);
    setImageModalVisible(true);
  };

  const renderClickableImage = (imageData: any, altText?: string) => {
    if (Array.isArray(imageData)) {
      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
          {imageData.map((src, index) => {
            if (!src) return null;
            return (
              <img
                key={index}
                src={typeof src === "object" && src?.url ? src.url : src}
                alt={altText || `image-${index}`}
                style={{ maxWidth: "200px", cursor: "pointer" }}
                onClick={() => handleImageClick(typeof src === "object" && src?.url ? src.url : src)}
              />
            );
          })}
        </div>
      );
    } else if (typeof imageData === "object" && imageData?.url) {
      return (
        <img
          src={imageData.url}
          alt={altText || "image"}
          style={{ maxWidth: "200px", cursor: "pointer" }}
          onClick={() => handleImageClick(imageData.url)}
        />
      );
    } else if (typeof imageData === "string") {
      return (
        <img
          src={imageData}
          alt={altText || "image"}
          style={{ maxWidth: "200px", cursor: "pointer" }}
          onClick={() => handleImageClick(imageData)}
        />
      );
    }
    return null;
  };

  const renderDynamicRowField = (field: Field) => {
    const dynamicData = get(data, field.fieldValue);
    if (!Array.isArray(dynamicData) || !field.rowConfig) return <Typography.Text>No data available</Typography.Text>;

    return (
      <div className="grid grid-cols-12 gap-5">
        {dynamicData.map((row: any, rowIndex: number) => (
          <div
            key={rowIndex}
            className="col-span-12"
          >
            {/* <Typography.Title level={5}>Row {rowIndex + 1}</Typography.Title> */}
            <div className="grid grid-cols-12 gap-4">
              {field.rowConfig![0].fields?.map((subField: any, subIndex: number) => {
                const subFieldValueKey = subField.name.split(".").pop();
                const subFieldValue = row[subFieldValueKey!];

                return (
                  <div
                    key={subIndex}
                    className="col-span-6"
                  >
                    <Typography.Title level={5}>{subField.label}</Typography.Title>
                    {subField.type === "text" || subField.type === "textarea" || subField.type === "mobile" ? (
                      <Typography.Text>{decodeValue(subFieldValue)}</Typography.Text>
                    ) : subField.type === "number" ? (
                      <Typography.Text>{subFieldValue}</Typography.Text>
                    ) : subField.type === "date" ? (
                      <Typography.Text>{getDateFormat(subFieldValue)}</Typography.Text>
                    ) : subField.type === "dateTime" ? (
                      <Typography.Text>{getFormattedDate(subFieldValue)}</Typography.Text>
                    ) : subField.type === "dateFormat" ? (
                      <Typography.Text>{getFormattedDate(subFieldValue)}</Typography.Text>
                    ) : subField.type === "checkbox" ? (
                      <Typography.Text>{subFieldValue ? "Yes" : "No"}</Typography.Text>
                    ) : subField.type === "image" ? (
                      // (() => {
                      //   const imageSrc = Array.isArray(subFieldValue) ? subFieldValue[0]?.url : subFieldValue;
                      //   if (!imageSrc) return null;
                      //   return (
                      //     <img
                      //       style={{ maxWidth: "200px" }}
                      //       src={imageSrc}
                      //       alt={`${subField.label}`}
                      //     />
                      //   );
                      // })()
                      renderImageColumn(subFieldValue)
                    ) : subField.type === "video" ? (
                      <video
                        controls
                        src={Array.isArray(subFieldValue) ? subFieldValue[0]?.url : subFieldValue || ""}
                        style={{ display: "inline-block", maxWidth: "200px" }}
                      />
                    ) : subField.type === "pdf" ? (
                      subFieldValue && (
                        <embed
                          src={Array.isArray(subFieldValue) ? subFieldValue[0]?.url : subFieldValue}
                          type="application/pdf"
                          width="100%"
                          height="400px"
                        />
                      )
                    ) : // subField.type === "select" ? (
                    //   <Typography.Text>
                    //     {(subField.loadOptions) ? (
                    //       <AsyncDataDisplay
                    //         field={subField}
                    //         value={get(data, `${subField.fieldValue}`)}
                    //       />
                    //     ) : (
                    //       get(data, `${subField.fieldValue}`)
                    //     )}
                    //   </Typography.Text>
                    // )
                    subField.type === "select" ? (
                      renderSelectValue(subField, subFieldValue)
                    ) : (
                      <Typography.Text>{subFieldValue || ""}</Typography.Text>
                    )}
                  </div>
                );
              })}
            </div>
            {rowIndex < dynamicData.length - 1 && <hr className="my-4 border-gray-300" />}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      {/* Reject Modal */}
      <ConfirmationModal
        type="reject"
        open={rejectModalVisible}
        onClose={() => setRejectModalVisible(false)}
        onSubmit={rejectRequest}
        // draftCount={draftCount}
        // moduleName="Our Profile"
      />

      {/* Approve Modal */}
      <ConfirmationModal
        type="approve"
        open={approveModalVisible}
        onClose={() => setApproveModalVisible(false)}
        onSubmit={approveRequest}
        draftCount={draftCount}
        moduleName={moduleName}
      />

      {isLoading ? (
        <span
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin size="large" />
        </span>
      ) : (
        <Drawer
          title={title}
          placement="right"
          closable={true}
          onClose={onClose}
          visible={visible}
          width={720}
        >
          {/* <h1 className="text-center text-2xl font-bold">{reviewNotes}</h1> */}
          {reviewNotes && (
            <>
              <div>
                <Typography.Title level={3}>Review Notes</Typography.Title>
                <Typography.Text>{reviewNotes}</Typography.Text>
              </div>
              <hr className="my-5 border-gray-300" />
            </>
          )}
          {airportName && (currentModule === "PASSENGER" || currentModule === "PASSENGER ECMS") && (
            <>
              <div>
                <Typography.Title level={3}>Airport</Typography.Title>
                <Typography.Text>{passengerAirportColumn(airportName)}</Typography.Text>
              </div>
              <hr className="my-5 border-gray-300" />
            </>
          )}
          <div className={"grid grid-cols-12 gap-5"}>
            {!Array.isArray(data)
              ? Array.isArray(fields) &&
                fields?.map((field, index) => {
                  try {
                    let parsedFieldData;

                    if (data && field.parseField) {
                      const parseFieldData = data[field.parseField];
                      parsedFieldData = parseFieldData;
                      if (typeof parseFieldData === "string") {
                        try {
                          parsedFieldData = JSON.parse(parseFieldData);
                        } catch (parseError) {
                          throw parseError;
                        }
                      } else if (typeof parseFieldData !== "object") {
                        throw new Error(`Expected a JSON string or object, but received: ${typeof parseFieldData}`);
                      }
                    }

                    return (
                      <div
                        key={index}
                        className={`col-span-12`}
                      >
                        <Typography.Title level={5}>{field.fieldName}</Typography.Title>
                        {field.type === "dynamicRow" && renderDynamicRowField(field)}
                        {!data && <Typography.Text>{decodeValue(field.fieldValue)}</Typography.Text>}
                        {/* {field.type === "select" && (
                        <Typography.Text>
                          {(field.loadOptions) ? (
                            <AsyncDataDisplay 
                              field={field} 
                              value={get(data, `${field.fieldValue}`)} 
                            />
                          ) : (
                            get(data, `${field.fieldValue}`)
                          )}
                        </Typography.Text>
                      )} */}
                        {field.type === "select" && renderSelectValue(field, get(data, field.fieldValue))}
                        {field.type === "date" && (
                          <Typography.Text>
                            {getDateFormat(get(data, `${field.fieldValue}.value`, get(data, field.fieldValue)))}
                          </Typography.Text>
                        )}
                        {field.type === "dateTime" && (
                          <Typography.Text>
                            {getFormattedDate(get(data, `${field.fieldValue}.value`, get(data, field.fieldValue)))}
                          </Typography.Text>
                        )}
                        {field.type === "dateFormat" && (
                          <Typography.Text>
                            {getStartDate(get(data, `${field.fieldValue}.value`, get(data, field.fieldValue)))}
                          </Typography.Text>
                        )}
                        {(field.type === "text" || field.type === "textarea" || field.type === "mobile") && (
                          <div className="flex items-center">
                            {field?.formType === "color" ? (
                              // If the formType is color, display the color along with the code
                              <div className="flex items-center">
                                <div
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    backgroundColor: get(data, `${field.fieldValue}`),
                                    marginRight: "8px",
                                    borderRadius: "4px",
                                  }}
                                />
                                <Typography.Text>{get(data, `${field.fieldValue}`)}</Typography.Text>
                              </div>
                            ) : (
                              // <Typography.Text>
                              //   {decodeValue(get(data, `${field.fieldValue}.value`, get(data, field.fieldValue)))}
                              // </Typography.Text>
                              (() => {
                                const raw = get(data, `${field.fieldValue}.value`, get(data, field.fieldValue));
                                if (Array.isArray(raw) && raw.length > 0) {
                                  return (
                                    <div className="flex flex-col">
                                      {raw.map((item: any, idx: number) => {
                                        const client = item?.client ?? item?.name ?? item ?? "";
                                        return (
                                          <Typography.Text
                                            key={idx}
                                            className="block"
                                          >
                                            {decodeValue(client)}
                                          </Typography.Text>
                                        );
                                      })}
                                    </div>
                                  );
                                }
                                if (Array.isArray(raw) && raw.length === 0) {
                                  return <Typography.Text>—</Typography.Text>;
                                }
                                return <Typography.Text>{decodeValue(raw ?? "")}</Typography.Text>;
                              })()
                            )}

                            {copyClipboard && field.fieldName === "ID" && (
                              <Tooltip title={`Copy ${field.fieldName} to clipboard`}>
                                <button
                                  onClick={() => {
                                    const value = get(data, `${field.fieldValue}`);
                                    navigator.clipboard.writeText(value.toString()).then(() => {
                                      openToast({
                                        content: `ID ${value.toString()} Copied to clipboard`,
                                        type: "success",
                                      });
                                    });
                                  }}
                                  className="ml-2 text-gray-500 hover:text-gray-700"
                                >
                                  <Icon icon="ant-design:copy-outlined" />
                                </button>
                              </Tooltip>
                            )}
                          </div>
                        )}

                        {data && field.type === "content" && field.parseField && (
                          <Typography.Text>
                            {(() => {
                              const value =
                                get(parsedFieldData, `${field.fieldValue}.value`) ||
                                get(parsedFieldData, field.fieldValue);

                              // Handle array of {value, label} objects
                              if (Array.isArray(value)) {
                                // Extract labels and join them with comma
                                const labels = value.filter((item) => item && item.label).map((item) => item.label);
                                return <div style={{ whiteSpace: "pre-line" }}>{decodeValue(labels.join("\n"))}</div>;
                              }

                              // Handle single {value, label} object
                              if (value && typeof value === "object" && value.label) {
                                return decodeValue(value.label);
                              }

                              // Default case
                              return decodeValue(value);
                            })()}
                          </Typography.Text>
                        )}
                        {/* {field.type === "checkbox" && (
                        <Typography.Text>{get(data, field.fieldValue) ? "Yes" : "No"}</Typography.Text>
                      )} */}
                        {field.type === "checkbox" && (
                          <Typography.Text>
                            {(() => {
                              const rawValue = get(data, field.fieldValue);
                              const normalized =
                                typeof rawValue === "boolean" ? rawValue : String(rawValue).toLowerCase() === "true";
                              return normalized ? "Yes" : "No";
                            })()}
                          </Typography.Text>
                        )}
                        {/* {field.type === "image" &&
                          (() => {
                            const finalData = parsedFieldData
                              ? get(parsedFieldData, `${field.fieldValue}.value`) ||
                                get(parsedFieldData, field.fieldValue)
                              : get(data, field.fieldValue);

                            if (!finalData) return null;

                            return renderImageColumn(finalData);
                          })()} */}
                        {field.type === "image" &&
                          (() => {
                            const finalData = parsedFieldData
                              ? get(parsedFieldData, `${field.fieldValue}.value`) ||
                                get(parsedFieldData, field.fieldValue)
                              : get(data, field.fieldValue);
                            if (!finalData) return null;
                            return renderClickableImage(finalData, field.fieldName);
                          })()}
                        {/* {field.type === "video" && (
                          <video
                            controls
                            src={
                              (Array.isArray(get(data, field.fieldValue))
                                ? get(data, field.fieldValue)[0]?.url
                                : get(data, field.fieldValue)) || ""
                            }
                            style={{ display: "inline-block", maxWidth: "200px" }}
                          />
                        )} */}

                        {field.type === "video" &&
                          (() => {
                            const videoSrc = Array.isArray(get(data, field.fieldValue))
                              ? get(data, field.fieldValue)[0]?.url
                              : get(data, field.fieldValue);

                            return videoSrc ? (
                              <video
                                controls
                                src={videoSrc}
                                style={{ display: "inline-block", maxWidth: "200px" }}
                              />
                            ) : null;
                          })()}

                        {field.type === "pdf" &&
                          (() => {
                            const pdfUrl = parsedFieldData
                              ? get(parsedFieldData, `${field.fieldValue}.value`) ||
                                get(parsedFieldData, field.fieldValue)
                              : get(data, field.fieldValue);

                            // Check if pdfUrl is an array and contains only objects with uid: "-1" or missing 'url'
                            const isInvalidPdf =
                              Array.isArray(pdfUrl) &&
                              pdfUrl.length > 0 &&
                              pdfUrl.every((item) => item?.uid === "-1" || !item?.url);

                            return (
                              pdfUrl &&
                              !isInvalidPdf && (
                                <div style={{ marginTop: "16px", maxWidth: "600px" }}>
                                  <embed
                                    src={Array.isArray(pdfUrl) ? pdfUrl[0]?.url : pdfUrl}
                                    type="application/pdf"
                                    width="100%"
                                    height="400px"
                                  />
                                </div>
                              )
                            );
                          })()}
                      </div>
                    );
                  } catch (err) {}
                })
              : data.map((data, dataIndex) => {
                  return (
                    <>
                      <div className="col-span-12">
                        <Typography.Title level={5}>{dataIndex + 1}</Typography.Title>
                      </div>
                      {fields &&
                        fields?.map((field, index) => {
                          try {
                            let parsedFieldData;

                            if (data && field.parseField) {
                              const parseFieldData = data[field.parseField];
                              parsedFieldData = parseFieldData;

                              if (typeof parseFieldData === "string") {
                                try {
                                  parsedFieldData = JSON.parse(parseFieldData);
                                } catch (parseError) {
                                  throw parseError;
                                }
                              } else if (typeof parseFieldData !== "object") {
                                throw new Error(
                                  `Expected a JSON string or object, but received: ${typeof parseFieldData}`
                                );
                              }
                            }

                            return (
                              <div
                                key={index}
                                className={`col-span-12`}
                              >
                                <Typography.Title level={5}>{field.fieldName}</Typography.Title>
                                {field.type === "dynamicRow" && renderDynamicRowField(field)}
                                {!data && <Typography.Text>{decodeValue(field.fieldValue)}</Typography.Text>}
                                {field.type === "select" && renderSelectValue(field, get(data, field.fieldValue))}
                                {field.type === "date" && (
                                  <Typography.Text>
                                    {getDateFormat(get(data, `${field.fieldValue}.value`, get(data, field.fieldValue)))}
                                  </Typography.Text>
                                )}
                                {field.type === "dateTime" && (
                                  <Typography.Text>
                                    {getFormattedDate(
                                      get(data, `${field.fieldValue}.value`, get(data, field.fieldValue))
                                    )}
                                  </Typography.Text>
                                )}
                                {field.type === "dateFormat" && (
                                  <Typography.Text>
                                    {getStartDate(get(data, `${field.fieldValue}.value`, get(data, field.fieldValue)))}
                                  </Typography.Text>
                                )}
                                {(field.type === "text" || field.type === "textarea" || field.type === "mobile") &&
                                  // <Typography.Text>
                                  //   {decodeValue(get(data, `${field.fieldValue}.value`, get(data, field.fieldValue)))}
                                  // </Typography.Text>
                                  (() => {
                                    const raw = get(data, `${field.fieldValue}.value`, get(data, field.fieldValue));
                                    if (Array.isArray(raw) && raw.length > 0) {
                                      return (
                                        <div className="flex flex-col">
                                          {raw.map((item: any, idx: number) => {
                                            const client = item?.client ?? item?.name ?? item ?? "";
                                            return (
                                              <Typography.Text
                                                key={idx}
                                                className="block"
                                              >
                                                {decodeValue(client)}
                                              </Typography.Text>
                                            );
                                          })}
                                        </div>
                                      );
                                    }
                                    if (Array.isArray(raw) && raw.length === 0) {
                                      return <Typography.Text>—</Typography.Text>;
                                    }
                                    return <Typography.Text>{decodeValue(raw ?? "")}</Typography.Text>;
                                  })()}
                                {data && field.type === "content" && field.parseField && (
                                  // <Typography.Text>
                                  //   {decodeValue(
                                  //     get(parsedFieldData, `${field.fieldValue}.value`) ||
                                  //       get(parsedFieldData, field.fieldValue)
                                  //   )}
                                  // </Typography.Text>
                                  <Typography.Text>
                                    {(() => {
                                      const value =
                                        get(parsedFieldData, `${field.fieldValue}.value`) ||
                                        get(parsedFieldData, field.fieldValue);

                                      // Handle array of {value, label} objects
                                      if (Array.isArray(value)) {
                                        // Extract labels and join them with comma
                                        const labels = value
                                          .filter((item) => item && item.label)
                                          .map((item) => item.label);
                                        return (
                                          <div style={{ whiteSpace: "pre-line" }}>{decodeValue(labels.join("\n"))}</div>
                                        );
                                      }

                                      // Handle single {value, label} object
                                      if (value && typeof value === "object" && value.label) {
                                        return decodeValue(value.label);
                                      }

                                      // Default case
                                      return decodeValue(value);
                                    })()}
                                  </Typography.Text>
                                )}
                                {/* {field.type === "checkbox" && (
                                  <Typography.Text>{get(data, field.fieldValue) ? "Yes" : "No"}</Typography.Text>
                                )} */}
                                {field.type === "checkbox" && (
                                  <Typography.Text>
                                    {(() => {
                                      const rawValue = get(data, field.fieldValue);
                                      const normalized =
                                        typeof rawValue === "boolean"
                                          ? rawValue
                                          : String(rawValue).toLowerCase() === "true";
                                      return normalized ? "Yes" : "No";
                                    })()}
                                  </Typography.Text>
                                )}
                                {field.type === "image" &&
                                  (() => {
                                    const finalData = parsedFieldData
                                      ? get(parsedFieldData, `${field.fieldValue}.value`) ||
                                        get(parsedFieldData, field.fieldValue)
                                      : get(data, field.fieldValue);

                                    if (!finalData) return null;

                                    return renderImageColumn(finalData);
                                  })()}

                                {field.type === "video" && (
                                  <video
                                    controls
                                    src={
                                      (Array.isArray(get(data, field.fieldValue))
                                        ? get(data, field.fieldValue)[0]?.url
                                        : get(data, field.fieldValue)) || ""
                                    }
                                    style={{ display: "inline-block", maxWidth: "200px" }}
                                  />
                                )}

                                {field.type === "pdf" &&
                                  (() => {
                                    const pdfUrl = Array.isArray(get(data, field.fieldValue))
                                      ? get(data, field.fieldValue)[0]?.url
                                      : get(data, field.fieldValue);

                                    return pdfUrl ? (
                                      <div style={{ marginTop: "16px", maxWidth: "600px" }}>
                                        <embed
                                          src={pdfUrl}
                                          type="application/pdf"
                                          width="100%"
                                          height="400px"
                                        />
                                      </div>
                                    ) : (
                                      <p></p>
                                    );
                                  })()}
                              </div>
                            );
                          } catch (err) {}
                        })}
                      <div className="col-span-12">
                        <hr />
                      </div>
                    </>
                  );
                })}
          </div>
          <div className="mt-5 flex flex-row-reverse gap-5">
            {actions &&
              actions.map((action, index) => (
                <Button
                  key={index}
                  // onClick={() => {
                  //   setOnClickFunction(() => {
                  //     return action.onClick;
                  //   });

                  //   if (action.label === "Reject") {
                  //     setRejectModalVisible(true);
                  //   } else if (action.label === "Approve") {
                  //     setApproveModalVisible(true);
                  //   }
                  // }}
                  onClick={() => {
                    if (action.disabled) return;
                    if (action.label === "Reply" && onReplyClick) {
                      onReplyClick();
                    } else {
                      setOnClickFunction(() => action.onClick);
                      if (action.label === "Reject") {
                        setRejectModalVisible(true);
                      } else if (action.label === "Approve") {
                        setApproveModalVisible(true);
                      }
                    }
                  }}
                  type={action.type ? action.type : "default"}
                  disabled={action.disabled}
                  style={{ marginLeft: index > 0 ? "10px" : 0 }}
                >
                  {action.label}
                </Button>
              ))}
          </div>
          <div>
            <Modal
              open={imageModalVisible}
              footer={null}
              closable={false} // hide default close
              onCancel={() => setImageModalVisible(false)}
              centered
              width={800}
              style={{
                maxWidth: "90vw",
                position: "relative", // modal container relative for absolute button
              }}
              maskClosable={true}
            >
              {/* Custom close icon floating outside modal */}
              <button
                onClick={() => setImageModalVisible(false)}
                style={{
                  position: "absolute", // relative to modal container
                  top: "-18px", // negative to float above modal
                  right: "-18px", // negative to float outside modal
                  background: "rgba(0,0,0,0.6)",
                  border: "none",
                  borderRadius: "50%",
                  color: "#fff",
                  cursor: "pointer",
                  zIndex: 1050,
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                }}
              >
                <Icon
                  icon="mdi:close"
                  width="20"
                  height="20"
                />
              </button>

              <img
                src={modalImageSrc}
                alt="Preview"
                style={{
                  width: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </Modal>
          </div>
        </Drawer>
      )}
    </>
  );
};
